/**
 * Exécution remboursement SAV depuis Caisse (testable, sans React).
 */

import {
  pickCaisseRefundApi,
  CAISSE_REFUND_API,
  getCaisseRefundBlockedMessage,
} from './caisseRefundApiRouting.js';

export const WEB_SURPLACE_REFUND_STORAGE_PREFIX = 'web-surplace-refund:';

export function webSurplaceRefundStorageKey(commandeId) {
  return `${WEB_SURPLACE_REFUND_STORAGE_PREFIX}${commandeId}`;
}

/**
 * @param {object} params
 * @param {object} params.ticketDetail
 * @param {object} params.payload
 * @param {string} params.commercantId
 * @param {{ rembourserTicket: Function, rembourserWebEncaisseEnCaisse: Function }} params.apiService
 * @param {() => string} params.createIdempotencyKey
 * @param {Pick<Storage, 'getItem'|'setItem'|'removeItem'>|null} [params.storage]
 */
export async function executeCaisseSavRefund({
  ticketDetail,
  payload,
  commercantId,
  apiService,
  createIdempotencyKey,
  storage = null,
}) {
  const route = pickCaisseRefundApi(ticketDetail);
  if (route === CAISSE_REFUND_API.BLOCKED) {
    return {
      blocked: true,
      message: getCaisseRefundBlockedMessage(ticketDetail),
    };
  }

  if (route === CAISSE_REFUND_API.WEB_ENCAISSE_ROUTE2) {
    const storageKey = webSurplaceRefundStorageKey(ticketDetail.id);
    let idemKey;
    try {
      idemKey = storage?.getItem(storageKey) || createIdempotencyKey();
      storage?.setItem(storageKey, idemKey);
    } catch {
      idemKey = createIdempotencyKey();
    }
    try {
      const result = await apiService.rembourserWebEncaisseEnCaisse(
        ticketDetail.id,
        payload,
        commercantId,
        { idempotencyKey: idemKey },
      );
      try {
        storage?.removeItem(storageKey);
      } catch {
        /* ignore */
      }
      return { blocked: false, route, result };
    } catch (err) {
      /* clé conservée pour retry idempotent (même demande financière) */
      throw err;
    }
  }

  const result = await apiService.rembourserTicket(ticketDetail.id, payload, commercantId);
  return { blocked: false, route, result };
}
